import { ProgressBar } from '@/components';
import {
  ArrowUpRightBoxIcon,
  Card,
  CurrencyValue,
  Flex,
  Text
} from '@blockanalitica/ui';
import { useTheme } from 'styled-components';

type DataResponse = {
  aave_total_farmed: string;
  v1_campaign_total_farmed: string;
  v2_campaign_total_farmed: string;
  total_farmed: string;
  sparklend_total_farmed: string;
  tokens_per_second: string;
};

export default function AirdropDistributionSection({
  data
}: {
  data: DataResponse;
}) {
  const theme = useTheme();

  const totalAmount = data['total_farmed'];

  const distributionData = [
    {
      name: (
        <Flex gap="2xs">
          <Text>SparkLend Season 1</Text>
          <Text color="muted" fontSize="-1">
            (Aug 20, 2023 - May 20, 2024)
          </Text>
        </Flex>
      ),
      percentage:
        Number(data['v1_campaign_total_farmed']) / Number(totalAmount),
      amount: data['v1_campaign_total_farmed'],
      color: theme.colors.sparkLendColor
    },
    {
      name: (
        <Flex gap="2xs">
          <Text>SparkLend Season 2</Text>
          <Text color="muted" fontSize="-1">
            (May 20, 2024 - June 16, 2025)
          </Text>
        </Flex>
      ),
      percentage:
        Number(data['v2_campaign_total_farmed']) / Number(totalAmount),
      amount: data['v2_campaign_total_farmed'],
      color: theme.colors.sparkSpkColor
    },
    {
      name: 'Aave',
      percentage: Number(data['aave_total_farmed']) / Number(totalAmount),
      amount: data['aave_total_farmed'],
      color: theme.colors.aaveColor
    }
  ];

  return (
    <Card gap="s">
      <Text fontSize="-1" color="muted">
        Spark SPK pre-farming airdrop rewards users based on their lending
        activity on SparkLend and Aave, distributing SPK tokens per block in
        Season 2 until the Sky Star launch. Borrowing USDS or DAI on SparkLend
        and supplying USDS on Aave earns the most rewards, with anti-gaming
        measures in place to prevent leveraged stablecoin looping.{' '}
        <Flex
          as="a"
          display="inline-flex"
          // @ts-ignore
          href="https://docs.spark.fi/governance/spk-token"
          target="_blank"
          rel="noreferrer">
          Learn more
          <ArrowUpRightBoxIcon size="-1" />
        </Flex>
      </Text>

      <Flex flexDirection="column" gap="m">
        {distributionData.map((row, index) => (
          <ProgressBar
            key={index}
            color={row.color}
            percent={row.percentage}
            text={row.name}
            additionalValue={<CurrencyValue value={row.amount} />}
          />
        ))}
      </Flex>
    </Card>
  );
}
